export default "__VITE_ASSET__jd1DrnaJ__"